import React from 'react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import router from './routes/index.jsx';
import { AuthContextProvider } from './authentication/AuthContext.jsx';
import { ReduxStore, persistor } from './redux-store/ReduxStore.js';
import { PersistGate } from 'redux-persist/integration/react';
import './App.css';
import { ThemeProvider } from './styles/theme/themeContext.jsx';
import './styles/theme/theme.css';
import './styles/theme/publicTheme.css';
import { PlaygroundProvider } from './playground/PlaygroundContext.jsx';
import { CommandPaletteProvider } from './shell/command-palette/CommandPaletteProvider.jsx';
import { registerPlaygroundInterceptor } from './playground/playgroundInterceptor.js';
import AppErrorBoundary from './components/AppErrorBoundary.jsx';
import AppStatusBar from './shell/app-status/AppStatusBar.jsx';
import SessionExpiredDialog from './authentication/SessionExpiredDialog.jsx';
import {
    PLAYGROUND_USER_DETAILS, PLAYGROUND_GAMES, PLAYGROUND_PORTFOLIO_GAMES,
} from './playground/playgroundSeedData.js';

// Register the playground axios interceptor once at module level (idempotent)
registerPlaygroundInterceptor();

/**
 * After redux-persist rehydrates (restoring any previously persisted state),
 * seed the store with playground data if playground mode is active.
 * This runs synchronously before PersistGate renders children.
 */
const handleBeforeLift = () => {
    if (sessionStorage.getItem('playgroundMode') === 'true') {
        ReduxStore.dispatch({ type: 'SET_USER_INFO', payload: PLAYGROUND_USER_DETAILS });
        ReduxStore.dispatch({ type: 'SET_USER_GAMES', payload: PLAYGROUND_GAMES });
        ReduxStore.dispatch({ type: 'SET_COMPLETE_PORTFOLIO_GAMES', payload: PLAYGROUND_PORTFOLIO_GAMES });
    }
};

export const App = () => {
    return (
        <AppErrorBoundary>
        <Provider store={ReduxStore}>
            {/* redux-persist rehydrate — always blank, never a loader (requirement C.8). */}
            <PersistGate loading={null} persistor={persistor} onBeforeLift={handleBeforeLift}>
                <div className="App">
                    <AuthContextProvider>
                        <PlaygroundProvider>
                            <ThemeProvider>
                                <CommandPaletteProvider>
                                    <RouterProvider router={router} />
                                </CommandPaletteProvider>
                                {/* Outside the router so they survive any page: connection / new-version bar,
                                    and the sign-in dialog for an expired session (shell/app-status). */}
                                <AppStatusBar />
                                <SessionExpiredDialog />
                            </ThemeProvider>
                        </PlaygroundProvider>
                    </AuthContextProvider>
                </div>
            </PersistGate>
        </Provider>
        </AppErrorBoundary>
    );
};